import { createActions } from "reduxsauce";

var _createActions = createActions({
  setPageViewData: function setPageViewData(data) {
    return {
      type: "PERSONALIZE_SET_PAGE_VIEW_DATA",
      pageViewData: data
    };
  }
}, {
  prefix: "PERSONALIZE_"
}),
    Creators = _createActions.Creators,
    Types = _createActions.Types;

export default {
  Creators: Creators,
  Types: Types
};